// src/pages/FAQPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageBack } from '../components/shared/PageBack';

const FAQS = [
  {
    section: 'For residents',
    items: [
      ['Is Gather free?', 'Yes — completely free to browse. No subscription, no ads, no catch.'],
      ['Do I need to create an account?', 'No. You can browse all events without signing up. You only need an account if you want to mark events as interested or post events.'],
      ['How do I add Gather to my home screen?', 'On iPhone: open in Safari, tap the share icon, then "Add to Home Screen". On Android: tap the three dots menu, then "Add to Home Screen".'],
      ['How current is the information?', 'Events are posted directly by local organisers, so information is as up to date as they keep it. If something looks wrong, contact the organiser directly.'],
    ],
  },
  {
    section: 'For organisers',
    items: [
      ['How do I post an event?', 'Register as an organiser from your profile page — it takes about 60 seconds. Once approved, you can post events straight away.'],
      ['Is it free to post events?', 'Yes. Posting events on Gather is completely free for community groups and local organisations.'],
      ['Can I edit or delete an event after posting?', 'Yes. Go to your organiser dashboard, find the event, and tap Edit or Delete.'],
      ['What types of events can I post?', 'Anything happening locally — sports, music, markets, classes, community meetings, fundraisers, and more.'],
      ['Can I post recurring events?', 'Yes. When posting an event, select whether it repeats weekly, fortnightly, or monthly.'],
    ],
  },
  {
    section: 'General',
    items: [
      ['Which towns is Gather available in?', 'We launched in Loughrea, Co. Galway and are expanding to more Irish towns. Get in touch if you\'d like Gather in your town.'],
      ['How do I contact you?', 'Email us at hello@gatheryourcommunity.com — we\'re a small team and we read everything.'],
    ],
  },
];

const FAQItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={s.item} onClick={() => setOpen(!open)}>
      <div style={s.question}>
        <span style={s.qText}>{q}</span>
        <span style={s.chevron}>{open ? '−' : '+'}</span>
      </div>
      {open && <div style={s.answer}>{a}</div>}
    </div>
  );
};

const FAQPage = () => {
  const navigate = useNavigate();
  return (
    <div style={s.page}>
      <button onClick={() => navigate(-1)} style={s.back}>
        <div style={s.backCircle}>←</div>
        <span style={s.backLbl}>Back</span>
      </button>

      <h1 style={s.h1}>Frequently asked questions</h1>
      <p style={s.lead}>Everything you need to know about Gather.</p>

      {FAQS.map(({ section, items }) => (
        <div key={section} style={s.section}>
          <div style={s.sectionTitle}>{section}</div>
          <div style={s.list}>
            {items.map(([q, a]) => <FAQItem key={q} q={q} a={a} />)}
          </div>
        </div>
      ))}

      <div style={s.card}>
        <div style={s.cardText}>Still have a question?</div>
        <button onClick={() => navigate('/contact')} style={s.contactBtn}>Contact us</button>
      </div>
      <PageBack position="bottom" fallbackPath="/profile" />
    </div>
  );
};

const s = {
  page: { background: '#fff', minHeight: '100vh', padding: '52px 24px 60px', maxWidth: 430, margin: '0 auto' },
  back: { display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', marginBottom: 24 },
  backCircle: { width: 34, height: 34, background: '#F8FBF8', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, color: '#2C4A2E' },
  backLbl: { fontSize: 13, color: '#4A6A4A', fontWeight: 600 },
  h1: { fontSize: 28, fontWeight: 800, color: '#1A2E1A', marginBottom: 10, letterSpacing: '-0.3px' },
  lead: { fontSize: 15, color: '#4A6A4A', marginBottom: 32, fontWeight: 500 },
  section: { marginBottom: 28 },
  sectionTitle: { fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.2px', color: '#1A7A4A', marginBottom: 10 },
  list: { display: 'flex', flexDirection: 'column', gap: 2 },
  item: { background: '#F8FBF8', borderRadius: 12, padding: '14px 16px', cursor: 'pointer', marginBottom: 2 },
  question: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 },
  qText: { fontSize: 14, fontWeight: 700, color: '#1A2E1A', lineHeight: 1.4 },
  chevron: { fontSize: 18, color: '#1A7A4A', fontWeight: 700, flexShrink: 0 },
  answer: { fontSize: 14, color: '#3A5A3A', lineHeight: 1.6, marginTop: 10, fontWeight: 500 },
  card: { background: '#EBF2EB', borderRadius: 16, padding: '20px', textAlign: 'center', marginTop: 16 },
  cardText: { fontSize: 14, color: '#2C4A2E', fontWeight: 500, marginBottom: 14 },
  contactBtn: { background: '#1A7A4A', color: 'white', border: 'none', borderRadius: 12, padding: '12px 24px', fontSize: 14, fontWeight: 700, fontFamily: 'Nunito, sans-serif', cursor: 'pointer' },
};

export default FAQPage;
